<template>
    <div class="title1">
        <P>巡视统计信息</P>
        <div class="title-info">Patrol statistics</div>
    </div>
    <div class="box">
        <ul class="box-list">
            <li v-for="(item,i) in list1" :key="i">
                <P>{{item.name}}</P>
                <div class="info-box">{{item.num}}</div>
            </li>
        </ul>
        <div class="boxEcharts" id="boxEcharts"></div>
    </div>
</template>

<script>
    import {onMounted, reactive,toRefs} from "vue";
    import {optiontwo} from "../../../public/js/echarts";
    import * as echarts from "echarts";
    import {EleResize} from "../../../public/js/esresize";
    export default {
        name: "patrol",
        
        setup(props){
        
       
            var list1 = reactive([
                {
                    name:'巡视总数',
                    num:5156,
                },{
                    name:'当日巡视',
                    num:11
                },{
                    name:'本月巡视',
                    num:21
                }
            ]);
             const drawLine = ()=>{
                    let option = optiontwo();
                    let myChart = echarts.init(document.getElementById("boxEcharts"));
                    myChart.setOption(option);
                    let listener = function() {
                        myChart.resize();
                    };
                    EleResize.on(document.getElementById("boxEcharts"), listener);
                };
            onMounted(()=>{
            	
//            setTimeout(()=>{
//            	 	drawLine();
//            },5000)
               
                window.addEventListener('resize',function(){
                	drawLine();
                })
            })
            return{
                list1,
                drawLine
            }
        }
    }
</script>

<style scoped lang="less">
    @import "./../../assets/canshu";
    .box{
        background: url("./../../assets/patrol-bg.png") no-repeat;
        background-size: 100% 100%;
        width: 363px;
        height: 283vh*@vh;
        margin-top: 26vh*@vh;
        font-family: cn;
        color: #fff;
        padding-top: 8vh*@vh;
        .box-list{
            display: flex;
            justify-content: space-around;
            li{
                p{
                    text-align: center;
                    font-size: 12px;
                    margin-bottom: 4vh*@vh;
                }
                .info-box{
                    width: 80px;
                    height: 21vh*@vh;
                    background: url("./../../assets/perceived-list1.png") no-repeat;
                    background-size: 100% 100%;
                    font-size: 14px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

            }
        }
        .boxEcharts{
            width: 100%;
            height: 70%;
        }
    }
</style>